export default __webpack_public_path__ + "static/media/Red0007.a04e7d54.png";